export default __webpack_public_path__ + "static/Mobile-Marketing-c4d9ed15b7c00bbb45c1a44f061a8997.png";